import { motion } from "framer-motion";
import { FadeInOut } from "../../../Util/animations/Animations_v2";
import MDSpinner from "react-md-spinner";
import { useContext } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const GradingLoader = () => {
  const { userData, primaryColor } = useContext(AppContext);

  return (
    <motion.div
      className="newGradingLoaderContainer"
      {...FadeInOut(userData.AnimationDisabled, 0.2)}
      key="newGradingLoaderContainer"
    >
      <MDSpinner size={60} singleColor={primaryColor} />
      <p className="newGradingLoaderText">Loading Grades</p>
    </motion.div>
  );
};

export default GradingLoader;
